import React from "react";
import { Link } from "react-router-dom";
import { Download } from "lucide-react";

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16.001 3.2C9.03 3.2 3.2 8.94 3.2 16.02c0 2.53.74 4.9 2.02 6.9L3.2 28.8l6.06-1.98a12.86 12.86 0 0 0 6.74 1.9h.01c7.03 0 12.79-5.74 12.79-12.8 0-3.42-1.34-6.63-3.76-9.05A12.7 12.7 0 0 0 16 3.2Zm7.5 18.2c-.32.9-1.86 1.72-2.58 1.78-.66.06-1.28.3-4.32-.96-3.66-1.5-6-5.28-6.18-5.52-.18-.24-1.5-2-1.5-3.82s.96-2.7 1.3-3.06c.34-.36.72-.45.96-.45l.7.01c.22.01.52-.08.82.63.32.78 1.08 2.64 1.18 2.83.1.19.16.42.03.66-.13.24-.19.39-.38.6-.19.21-.4.47-.57.63-.19.19-.39.4-.17.78.22.38.98 1.62 2.1 2.62 1.44 1.28 2.66 1.68 3.04 1.87.38.19.6.16.82-.1.22-.25.94-1.1 1.19-1.48.25-.38.5-.32.84-.19.34.13 2.16 1.02 2.53 1.2.38.19.63.28.72.44.09.16.09.9-.23 1.8Z"/>
  </svg>
);

const Navbar = ({ downloadUrl = "#" }) => {
  return (
    <header className="absolute top-0 left-0 right-0 z-20">
      <nav className="max-w-6xl mx-auto flex items-center justify-between px-5 sm:px-8 h-16">
        <Link to="/" className="flex items-center gap-2">
          <span className="text-[#25D366]">
            <WhatsAppIcon className="w-7 h-7" />
          </span>
          <span className="font-display font-bold text-lg text-[#25D366] tracking-tight">WhatsApp</span>
        </Link>
        <a
          href={downloadUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1fb757] text-white font-semibold text-sm px-5 py-2 rounded-full transition-colors"
        >
          <Download className="w-4 h-4" />
          Download
        </a>
      </nav>
    </header>
  );
};

export { WhatsAppIcon };
export default Navbar;
